import React, { useCallback, useEffect, useState } from 'react';
import { FaTimes } from 'react-icons/fa';
import user_icon from '../../../../assets/icons/user.svg';
import trash_icon from '../../../../assets/icons/delete.svg';
import WorkPerformanceGraph from './WorkPerformanceGraph';
import axiosInstance from 'config/axiosInstance';
import { useNavigate } from 'react-router-dom';
import AssignedDevicePopup from '../AssignDevicePopup';
import { useTranslation } from 'react-i18next';

interface DriverAlcoholSubmissionsTableProps {
  id?: string;
}

const DriverDetailTable: React.FC<DriverAlcoholSubmissionsTableProps> = ({ id }) => {
  const { t, i18n } = useTranslation('driver');
  const [driver, setDriver] = useState<any>(null);
  const [originalDriver, setOriginalDriver] = useState<any>(null);
  const [timePeriod, setTimePeriod] = useState('Monthly');
  const [showConfirmDelete, setShowConfirmDelete] = useState(false);
  const [showPopup, setShowPopup] = useState(false);
  const [popupMessage, setPopupMessage] = useState('');
  const [showDevicePopup, setShowDevicePopup] = useState(false);

  const navigate = useNavigate();

  const [vehicleInspection, setVehicleInspection] = useState('Unchecked');
  const [drivinglicense, setDriverlicense] = useState('Unchecked');
  const [healthcheck, setHealthcheck] = useState('Unchecked');
  const [checkinout, setCheckinout] = useState('Unchecked');
  const [latestTest, setLatestTest] = useState(0);
  const [assignedDeviceCount, setAssignedDeviceCount] = useState(0);
  const [totalTest, setTotalTest] = useState(0);
  const [totalWorkingHrs, setTotalWorkingHrs] = useState(0);

  const getCurrentDateFormatted = (): string => {
    const today = new Date();
    const year = today.getFullYear();
    const month = String(today.getMonth() + 1).padStart(2, '0');
    const day = String(today.getDate()).padStart(2, '0');
    return `${year}-${month}-${day}`;
  };

  const todayDate = getCurrentDateFormatted();

  const fetchData = useCallback(async () => {
    try {
      
      const driverResponse = await axiosInstance.get(`/v1/drivers/${id}/`);
      const driverData = driverResponse.data;

      setDriver(driverData);
      setOriginalDriver(driverData);
      setAssignedDeviceCount(driverData.devices?.length || 0);

      
      const [
        vehicleInspectionResponse,
        drivinglicenseResponse,
        healthcheckResponse,
        checkinoutResponse,
        totalTestResponse,
        totalWorkingHrs,
      ] = await Promise.all([
        axiosInstance.get(`/v1/vehicle_inspection_records/?create_time__gte=${todayDate}T00%3A00%3A00.000000Z&create_time__lte=${todayDate}T23%3A59%3A59.999999Z&inspecion_result=true&user=${id}`),
        axiosInstance.get(`/v1/scan_ic_records/?create_time__gte=${todayDate}T00%3A00%3A00.000000Z&create_time__lte=${todayDate}T23%3A59%3A59.999999Z&user=${id}`),
        axiosInstance.get(`/v1/health_inspection_records/?create_time__gte=${todayDate}T00%3A00%3A00.000000Z&create_time__lte=${todayDate}T23%3A59%3A59.999999Z&user=${id}`),
        axiosInstance.get(`/v1/attendances/?user=${id}`),
        axiosInstance.get(`/v1/alcohol_tests/?user=${id}`),
        axiosInstance.get(`/v1/attendances/total_hour/?user=${id}`)
      ]);

      setVehicleInspection(vehicleInspectionResponse.data.count > 0 ? `${t('view.driver-detail.work-info.status-check')}` : `${t('view.driver-detail.work-info.status-uncheck')}`);
      setDriverlicense(drivinglicenseResponse.data.results?.length > 0 ? `${t('view.driver-detail.work-info.status-check')}` : `${t('view.driver-detail.work-info.status-uncheck')}`);
      setHealthcheck(healthcheckResponse.data.results?.length > 0 ? `${t('view.driver-detail.work-info.status-check')}` : `${t('view.driver-detail.work-info.status-uncheck')}`);
      setCheckinout(checkinoutResponse.data.results[0]?.check_out === null ? `${t('view.driver-detail.work-info.status-working')}` : `${t('view.driver-detail.work-info.status-clockout')}`)
      setTotalTest(totalTestResponse.data.count);
      setTotalWorkingHrs(totalWorkingHrs.data.total_hour);

    } catch (error) {
      console.error('Failed to fetch driver data', error);
    }
  }, [id, todayDate]);

  useEffect(() => {
    if (id) {
      fetchData();
    }
  }, [id, fetchData]);

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { name, value } = e.target;
    setDriver((prevDriver: any) => ({
      ...prevDriver,
      [name]: value,
    }));
  };

  const handleTimePeriodChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
    setTimePeriod(e.target.value);
  };

  const handleSaveChanges = async () => {
    if (JSON.stringify(driver) !== JSON.stringify(originalDriver)) {
      const updatedFields = {
        email: driver.email,
        name: driver.name,
        phone: driver.phone,
        birthday: driver.birthday,
      };

      try {
        const Driverapi = `/v1/drivers/${id}/`;
        await axiosInstance.patch(Driverapi, updatedFields);
        setOriginalDriver(driver);
        setPopupMessage(`${t('view.driver-detail.popup.save-success')}`);
        setShowPopup(true);
      } catch (error) {
        console.error('Failed to save driver data', error);
        setPopupMessage(`${t('view.driver-detail.popup.save-failed')}`);
        setShowPopup(true);
      }
    } else {
      setPopupMessage(`${t('view.driver-detail.popup.save-no-detect')}`);
      setShowPopup(true);
    }
  };

  const handleCancel = () => {
    setDriver(originalDriver); 
  };

  const handleDeleteDriver = async () => {
    try {
      const Driverapi = `/v1/drivers/${id}/`;
      await axiosInstance.delete(Driverapi);
      navigate(`/driver`);
    } catch (error) {
      console.error('Failed to delete driver', error);
      alert('Failed to delete driver');
    } finally {
      setShowConfirmDelete(false);
    }
  };

  const toggleAssignedDevicePopup = () => {
    setShowDevicePopup(!showDevicePopup);
  };
  console.log(t);
  return (
    <section className="flex flex-row p-4 space-x-4">
      {showConfirmDelete && (
        <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 z-50">
          <div className="bg-white py-4 rounded-md shadow-md relative">
            <FaTimes
              className="absolute top-2 right-2 h-6 w-6 cursor-pointer"
              onClick={() => setShowConfirmDelete(false)}
            />
            <h6 className="text-subtitle-1 font-semi-bold px-4">Account Deletion</h6>
            <div className="border-y py-8">
              <p className="px-4">
                Are you sure to remove this driver{' '}
                <span className="font-semi-bold">{driver?.name}</span> from the system?
              </p>
              <p className="px-4">This cannot be undone</p>
            </div>
            <div className="flex justify-end space-x-2 mt-4 px-4">
              <button
                className="flex-1 border border-gray-300 text-gray-500 rounded-md px-4 py-2"
                onClick={() => setShowConfirmDelete(false)}
              >
                Cancel
              </button>
              <button
                className="flex-1 bg-red-500 text-white rounded-md px-4 py-2"
                onClick={handleDeleteDriver}
              >
                Delete
              </button>
            </div>
          </div>
        </div>
      )}
      {showPopup && (
        <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 z-50">
          <div className="bg-white p-4 rounded-md shadow-md">
            <p>{popupMessage}</p>
            <div className="flex justify-end space-x-2 mt-4">
              <button
                className="bg-gray-300 rounded-md px-4 py-2"
                onClick={() => setShowPopup(false)}
              >
                Close
              </button>
            </div>
          </div>
        </div>
      )}
      {showDevicePopup && (
        <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 z-50">
          <div className="bg-white rounded-md shadow-md w-1/3">
            <AssignedDevicePopup onClose={toggleAssignedDevicePopup} /> {/* Pass onClose prop */}
          </div>
        </div>
      )}
      <div className="w-1/3 border rounded-md p-2 space-y-4">
        <div className="flex flex-row justify-between p-2">
          <h4 className="text-title ">{t('view.driver-detail.personal-details.title')}</h4>
          <img
            src={trash_icon}
            alt="User Icon"
            className="h-8 cursor-pointer"
            onClick={() => setShowConfirmDelete(true)}
          />
        </div>
        <div className="flex flex-col space-y-2 text-gray-500">
          <div className='flex items-center justify-center'>
            <img src={driver?.profile_picture || user_icon} alt="User Icon" className="flex h-64 w-64 object-cover rounded-full" />
          </div>
          <div className="flex flex-col">
            <label htmlFor="name">{t('view.driver-detail.personal-details.fullname')}</label>
            <input
              type="text"
              name="name"
              className="border rounded-md p-2 text-black"
              value={driver?.name || ''}
              onChange={handleChange}
            />
          </div>
          <div className="flex flex-col">
            <label htmlFor="birthday">{t('view.driver-detail.personal-details.dob')}</label>
            <input
              type="date"
              name="birthday"
              className="border rounded-md p-2 text-black"
              value={driver?.birthday || ''}
              onChange={handleChange}
            />
          </div>
          <div className="flex flex-col">
            <label htmlFor="phone">{t('view.driver-detail.personal-details.contact')}</label>
            <input
              type="text"
              name="phone"
              className="border rounded-md p-2 text-black"
              value={driver?.phone || ''}
              onChange={handleChange}
            />
          </div>
          <div className="flex flex-col">
            <label htmlFor="email">{t('view.driver-detail.personal-details.email')}</label>
            <input
              type="text"
              name="email"
              className="border rounded-md p-2 text-black"
              value={driver?.email || ''}
              onChange={handleChange}
            />
          </div>
          <div className="flex flex-row justify-between space-x-2">
            <div className="flex flex-1 flex-col">
              <label>{t('view.driver-detail.personal-details.driver-id')}</label>
              <p className="border rounded-md p-2 text-gray-500 bg-gray-200">{id}</p>
            </div>
            <div className="flex flex-1 flex-col ">
              <label>{t('view.driver-detail.personal-details.registered')}</label>
              <input
                type="text"
                className="border rounded-md p-2 text-gray-500 bg-gray-200"
                value={driver?.create_time?.substring(0, 10) || ''}
                readOnly
              />
            </div>
          </div>
        </div>
        <div className="flex flex-row space-x-2">
          <button
            className="flex-1 bg-primary/300 text-white rounded-md p-2"
            onClick={handleSaveChanges}
          >
            {t('view.driver-detail.personal-details.save')}
          </button>
          <button
            className="flex-1 bg-primary/50 text-primary/300 rounded-md p-2"
            onClick={handleCancel}
          >
            {t('view.driver-detail.personal-details.cancel')}
          </button>
        </div>
      </div>
      <div className="flex flex-col w-2/3 space-y-2">
        <div className="flex flex-row space-x-2">
          <div className="flex flex-1 flex-col border rounded-md p-4 space-y-4">
            <h4 className="text-title">{t('view.driver-detail.work-info.title')}</h4>
            <div className="flex flex-col space-y-4 text-gray-400">
              <div className="flex flex-row justify-between ">
                <p>{t('view.driver-detail.work-info.vehicle-inspection')}</p>
                <p
                  className={`rounded-md px-4 py-1 w-28 text-center ${
                    vehicleInspection === 'Checked' || vehicleInspection === 'Check JP'
                      ? 'bg-[#CEFDFF] text-black'
                      : 'bg-[#FFE5EE] text-[#DD0000]'
                  }`}
                >
                  {vehicleInspection}
                </p>
              </div>
              <div className="flex flex-row justify-between">
                <p>{t('view.driver-detail.work-info.health-check')}</p>
                <p
                  className={`rounded-md px-4 py-1 w-28 text-center ${
                    healthcheck === 'Checked' || healthcheck === 'Check JP'
                      ? 'bg-[#CEFDFF] text-black'
                      : 'bg-[#FFE5EE] text-[#DD0000]'
                  }`}
                >
                  {healthcheck}
                </p>
              </div>
              <div className="flex flex-row justify-between">
                <p>{t('view.driver-detail.work-info.driving-license')}</p>
                <p
                  className={`rounded-md px-4 py-1 w-28 text-center ${
                    drivinglicense === 'Checked' || drivinglicense === 'Check JP'
                      ? 'bg-[#CEFDFF] text-black'
                      : 'bg-[#FFE5EE] text-[#DD0000]'
                  }`}
                >
                  {drivinglicense}
                </p>
              </div>
              <div className="flex flex-row justify-between">
                <p>{t('view.driver-detail.work-info.checkin-checkout')}</p>
                <p
                  className={`rounded-md px-4 py-1 w-28 text-center ${
                    checkinout === 'Working' || checkinout === 'Working JP'
                      ? 'bg-[#CEFDFF] text-black'
                      : 'bg-[#FFE5EE] text-[#DD0000]'
                  }`}
                >
                  {checkinout}
                </p>
              </div>
            </div>
          </div>
          <div className="flex flex-1 flex-col border rounded-md p-4 space-y-8">
            <h4 className="text-title">{t('view.driver-detail.alcohol-status.title')}</h4>
            <div className="flex flex-col space-y-8 text-gray-400">
              <div className="flex flex-row justify-between">
                <p>{t('view.driver-detail.alcohol-status.lastest-test')}</p>
                <p
                  className={` rounded-md px-4 py-1  w-28 text-center ${
                    latestTest <= 0
                      ? 'bg-primary/50 text-[#41A644]'
                      : 'bg-[#FFE5EE] text-[#DD0000]'
                  }`}
                >
                  {latestTest} mg/L
                </p>
              </div>
              <div className="flex flex-row justify-between">
                <p>{t('view.driver-detail.alcohol-status.assigned-device')}</p>
                <p
                  className="text-primary/300 underline cursor-pointer"
                  onClick={toggleAssignedDevicePopup} 
                >
                  {assignedDeviceCount}+ {t('view.driver-detail.alcohol-status.device')}
                </p>
              </div>
              <div className="flex flex-row justify-between ">
                <p>{t('view.driver-detail.alcohol-status.total-test')}</p>
                <p
                  className={`rounded-md px-4 py-1  w-28 text-right text-black`}>
                  {totalTest}
                </p>
              </div>
            </div>
          </div>
        </div>
        <div className="border rounded-md p-4">
          <div className="flex flex-row justify-between">
            <div className="flex flex-col">
              <h4 className="text-title">{t('view.driver-detail.work-performance.title')}</h4>
              <p className="text-gray-500">{t('view.driver-detail.work-performance.info')} {Math.round(totalWorkingHrs)} {t('view.driver-detail.work-performance.hrs')}</p>
            </div>
            <div>
              <p className='border rounded-md py-2 px-4'>{t('view.driver-detail.work-performance.monthly')}</p>
            </div>
          </div>
          <div className="h-96">
            {/* graph */}
            <WorkPerformanceGraph />
          </div>
        </div>
      </div>
    </section>
  );
};

export default DriverDetailTable;